import { PERMS } from '@/config/permissions';
import DefaultLayout from '@/layouts/DefaultLayout.vue';

const PieceworkStats = () => import('@/modules/payroll/piecework/PieceworkStats.vue');
const SalaryGenerate = () => import('@/modules/payroll/salary/SalaryGenerate.vue');

export const payrollRoutes = {
  path: '/payroll',
  name: 'Payroll',
  component: DefaultLayout,
  meta: {
    title: '薪资管理',
    titleKey: 'route.payroll',
    icon: 'Grid',
    order: 4,
  },
  children: [
    {
      path: 'piecework',
      name: 'Piecework',
      component: PieceworkStats,
      meta: {
        title: '日工资统计',
        titleKey: 'route.piecework',
        icon: 'pie-chart',
        order: 40,
        permissions: [PERMS.SALARY_VIEW],
      },
    },
    {
      path: 'salary',
      name: 'SalaryGenerate',
      component: SalaryGenerate,
      meta: {
        title: '月度工资',
        titleKey: 'route.salaryGenerate',
        icon: 'money-collect',
        order: 42,
        permissions: [PERMS.SALARY_VIEW],
        // permissions: [PERMS.PAYROLL_SALARY_GENERATE],
      },
    },
  ],
};
